import { render } from "./MenuBar.vue?vue&type=template&id=38877a87&scoped=true"
import script from "./MenuBar.vue?vue&type=script&lang=js"
export * from "./MenuBar.vue?vue&type=script&lang=js"

import "./MenuBar.vue?vue&type=style&index=0&id=38877a87&scoped=true&lang=css"

import exportComponent from "/home/runner/work/GPSviaAIS/GPSviaAIS/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38877a87"]])

export default __exports__